const imageCaptionDefinitions = [
  // {
  //   page: '5',
  //   left: '36%',
  //   top: '18%',
  //   width: '50%',
  //   parallax: 0.12,
  //   items: [
  //     {
  //       image: './pages/LBN-Pages-4a.jpg',
  //       alt: 'Lorem ipsum dolor sit amet adipiscing elit',
  //       title: 'Lorem ipsum dolor sit amet adipiscing elit.',
  //       description: 'Lorem ipsum dolor sit amet consectetur adipiscing elit. Quisque faucibus ex sapien vitae pellentesque sem placerat. In id cursus mi pretium tellus duis convallis.',
  //     },
  //     {
  //       image: './pages/LBN-Pages-4b.jpg',
  //       alt: 'Lorem ipsum dolor sit amet adipiscing elit',
  //       title: 'Lorem ipsum dolor sit amet adipiscing elit.',
  //       description: 'Lorem ipsum dolor sit amet consectetur adipiscing elit. Quisque faucibus ex sapien vitae pellentesque sem placerat. In id cursus mi pretium tellus duis convallis.',
  //     },
  //   ],
  //   mobile: {
  //     left: '8%',
  //     top: '47%',
  //     width: '92%',
  //     parallax: 0.04,
  //   },
  // },
];

export default imageCaptionDefinitions;